import { render, staticRenderFns } from "./Assureur.vue?vue&type=template&id=887242e4&"
import script from "./Assureur.vue?vue&type=script&lang=js&"
export * from "./Assureur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports